import { useUserStore } from "~//stores/login/user";

export default defineNuxtRouteMiddleware(async (to, from) => {

const  { session, refresh} = await useSession()

const user = useUserStore()

if(!user.loggedIn) return navigateTo('/login-admin');

})
